'use strict'

const state = { costCenterTemporaryDisabled: false }

const actions = {
  set ({ commit }, payload) {
    commit('set', payload)
  }
}

const mutations = {
  set ({ commit }, payload) {
    state.costCenterTemporaryDisabled = payload.costCenterTemporaryDisabled
  }
}

const globalDrawer = {
  namespaced: true,
  state,
  actions,
  mutations
}

export default globalDrawer
